import { getCookie, setCookie } from 'cookies-next'
import { atom } from 'jotai'
import { z } from 'zod'

export type UserSettings = {
  hideSmallBalances: boolean
  smallestBalanceUsd: number
  maskBalances: boolean
}

const UserSettingsSchema = z.object({
  hideSmallBalances: z.boolean(),
  smallestBalanceUsd: z.number(),
  maskBalances: z.boolean(),
})

const defaultSettings: UserSettings = {
  hideSmallBalances: true,
  smallestBalanceUsd: 0.05,
  maskBalances: false,
}

// This needs to be updated if there are breaking changes
// to avoid breaking existing users.
// A migration may be needed if there is existing important data
const cookieKey = 'user-settings-v2'

export const loadSettings = (): UserSettings => {
  const settingsCookie = getCookie(cookieKey)
  if (typeof settingsCookie !== 'string' || !settingsCookie) {
    return defaultSettings
  }
  try {
    const settings = JSON.parse(settingsCookie)
    const validation = UserSettingsSchema.safeParse(settings)
    if (validation.success) {
      return validation.data
    }
  } catch {
    // ignore
  }

  return defaultSettings
}

export const saveSettings = (settings: UserSettings): void => {
  setCookie(cookieKey, JSON.stringify(settings))
}

export const userSettingsAtom = atom<UserSettings>(defaultSettings)
